export default __webpack_public_path__ + "static/media/LF-2Open.c2e13b95.jpg";